import AbstractCommand from '../AbstractCommand';
import InvoiceConceptModel from '../../stores/models/InvoiceConceptModel';
import publicInvoiceGet from '../../requests/invoices/publicInvoiceGet';

/**
 *
 */
export default class GetPublicInvoiceCommand extends AbstractCommand {
	/**
	 *
	 * @param invoiceConceptModel InvoiceConceptModel
	 * @param uuid string
	 */
	constructor(invoiceConceptModel, uuid) {
		super();

		this.invoiceConceptModel = invoiceConceptModel;
		this.uuid = uuid;
	}

	/**
	 *
	 * @param success
	 * @param error
	 */
	execute(success, error) {
		return publicInvoiceGet(this.uuid)
			.then((response) => {
				InvoiceConceptModel.updateInvoiceConcept(response.data, this.invoiceConceptModel);

				if (success) {
					success(response);
				}
			})
			.catch((err) => {
				if (error) {
					error(err);
				}
			});
	}
}
